var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('h1',[_vm._v("Oops!")]),_c('p',[_vm._v("This page does not exist. "),_c('router-link',{attrs:{"to":"/"}},[_vm._v("Click here")]),_vm._v(" to return to Project QWERTY.")],1)])}
var staticRenderFns = []

export { render, staticRenderFns }